/* eslint-disable */
import { produce } from "immer";
import {
  CONNECTED_PENSION_FETCH_FAILURE,
  CONNECTED_PENSION_FETCH_SUCCESS,
  CONNECTED_PENSION_FETCH_START,
} from "../actions/types";

const connectedPension = (
  state = {
    fetching: false,
    data: [],
    error: null,
  },
  action,
) => {
  switch (action.type) {
    case CONNECTED_PENSION_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case CONNECTED_PENSION_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case CONNECTED_PENSION_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default connectedPension;
